<template>
	<!-- 申请退费 -->
	<div class="applyRefund">
		<publicHeader :pageTitle="pageTitle" isWhite="true"></publicHeader>
		<!-- 占位 -->
		<div class="zhanwei"></div>
		<!-- 退费详情 -->
		<div class="refundInfo">
			<div class="refundInfo_1">
				<div class="refundInfoItem">
					<div class="vipName typeItem">会员名称</div>
					<div class="vipNameVal valItem">{{refundInfo.vipName}}</div>
				</div>
				<div class="refundInfoItem" v-if="refundInfo.deadline">
					<div class="delineTime typeItem">到期日期</div>
					<div class="delineTimeVal valItem">{{refundInfo.deadline}}</div>
				</div>
				<div class="refundInfoItem">
					<div class="residueTime typeItem">剩余时长（天）</div>
					<div class="residueTimeVal valIteml"
						v-if="refundInfo.remainDays <= 0 || refundInfo.remainDays == ''">0</div>
					<div class="residueTimeVal valIteml" v-else>{{refundInfo.remainDays}}</div>
				</div>
				<div class="refundInfoItem refundEstimatedAmount">
					<div class="refundEstimatedAmount_1">
						<div class="typeItem">
							<div class="estimatedAmount">退款预估金额（元）</div>
							<div class="estimatedAmountVal"><span
									class="icon_price">¥</span>{{refundInfo.expectAccount}}</div>
						</div>
						<div class="annotation">注：退款金额以实际为准</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 收款账户 -->
		<div class="collectionBody">
			<div class="collectionAccount ">
				<div class="collectionTitle">收款账户</div>
				<div class="collectionPrompt">为保证顺利完成退款，请提交支付宝收款账户</div>
			</div>
			<van-cell-group class="filedInfo">
				<van-field v-model="accountVal" required placeholder="请输入支付宝账号" maxlength="40"/>
				<van-field v-model="nameVal" required placeholder="输入支付宝认证姓名" maxlength="18"/>
				<van-field v-model="phoneVal" type="number" required placeholder="请输入联系手机号" maxlength="11"/>
			</van-cell-group>
		</div>
		<!-- 提交展示确认收款信息弹框 -->
		<div :class="isCheck?'submit':'disbled'" v-if="isShowSubmit">
			<div @click="submit">提交</div>
		</div>

		<div class="prompt" v-show="prompt">
			<div class="promptDialog">
				<div class="promptTitle">请输入收款信息</div>
				<div class="notice">收款人姓名与收款人账户不一致，可能无法完成收款，请谨慎确认</div>
				<div class="promptAccount">
					<div class="">支付宝账号</div>
					<div class="prompt_val">{{accountVal}}</div>
				</div>
				<div class="promptAccount">
					<div class="">姓名</div>
					<div class="prompt_val">{{nameVal}}</div>
				</div>
				<div class="promptAccount">
					<div class="">联系手机号</div>
					<div class="prompt_val">{{phoneVal}}</div>
				</div>
				<div class="promptBtn">
					<div class="cancelBtn" @click="cancelRefund">取消</div>
					<div class="confirm" @click="confirmRefund">确认</div>
				</div>
			</div>
		</div>
		<publicToast :info='info' v-show="info"></publicToast>
	</div>
</template>

<script>
	import publicHeader from '../components/PublicHeader'
	import publicToast from '../components/publicToast'

	export default {
		name: 'applyRefund',
		components: {
			publicHeader,
			publicToast
		},
		data() {
			return {
				pageTitle:'',
				id:'',
				info: '',
				accountVal: '',
				nameVal: '',
				phoneVal: '',
				prompt: false,
				refundInfo: {},
				isCheck: false,
				scrollHeight: "", //页面的总高度 1734
				scrolltop: "", //滚动条的最高长度 1306
				keshi: "", //页面的可视区域
				isIos: '',
				isShowSubmit: true,
				clientHeight: document.documentElement.clientHeight
			}
		},
		created() {
			this.isIos =
				navigator.userAgent.indexOf('Mac OS') > -1 ||
				!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
			this.pageTitle = '申请退费'
			this.getToken()
			this.getRefundInfo()
		},
		mounted() {
			window.onresize = () => {
				if (this.clientHeight > document.documentElement.clientHeight) {
					this.isShowSubmit = false;
				} else {
					this.isShowSubmit = true;
				}
			}
		},
		watch: {
			accountVal(val) {
				if (val != '') {
					this.isAccount = true;
				} else {
					this.isAccount = false;
				}
				if (this.isAccount && this.isName && this.isPhone) {
					this.isCheck = true;
				} else {
					this.isCheck = false;
				}
			},
			nameVal(val) {
				if (val != '') {
					this.isName = true
				} else {
					this.isName = false;
				}
				if (this.isAccount && this.isName && this.isPhone) {
					this.isCheck = true;
				} else {
					this.isCheck = false;
				}
			},
			phoneVal(val) {
				const reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
				if (val != '' && reg_tel.test(val)) {
					this.isPhone = val
				} else {
					this.isPhone = false;
				}
				if (this.isAccount && this.isName && this.isPhone) {
					this.isCheck = true;
				} else {
					this.isCheck = false;
				}
			}
		},
		methods: {
			// 获取退款预估金额
			getRefundInfo() {
				const params = {
					token: this.token,
					vipId: this.vipId, //会员卡id
					needMoney: 1 //是否需要返回预估金额 1需要 0不需要

				}
				this.$vipapi.getRefundInfo(params).then(res => {
					console.log('会员信息', res)
					this.refundInfo = res.data.data;
				})
			},
			// 提交退款
			submit() {
				if (this.isCheck) {
					this.prompt = true;
				} else {
					if(!this.isAccount){
						this.info = '支付宝账户不能为空'
					}else if(!this.isName){
						this.info = '姓名不能为空'
					}else{
						if(!this.phoneVal){
							this.info = '手机号不能为空'
						}else{
							this.info = '手机号格式错误'
						}
					}
					setTimeout(this.hideInfo, 1500)
				}

			},
			cancelRefund() {
				this.prompt = false;
			},
			// 提交退款
			confirmRefund() {
				this.prompt = false;
				this.$vipapi.submitRefund(
					`token=${this.token}&vipId=${this.vipId}&name=${this.nameVal}&account=${this.accountVal}&mobile=${this.phoneVal}`
				).then(res => {
					console.log('提交退款', res)
					if (res.data.control.status == 200) {
						this.info = `${res.data.control.message}`
						this.id = res.data.data.refundId;
						setTimeout(this.hideInfo, 1000)
						setTimeout(this.gotoViprefundinfo, 1000)
					} else {
						this.info = `${res.data.control.message}`
						setTimeout(this.hideInfo, 1500)
					}
				})

			},
			gotoViprefundinfo() {
				this.$router.push(`/viprefundinfo?token=${this.token}&vipId=${this.vipId}&id=${this.id}`)
			},
			// 隐藏toast提示
			hideInfo() {
				this.info = ''
			},
			// 获取url上的信息
			getcommit(name) {
				return (
					decodeURIComponent(
						(new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
							location.href
						) || ['', ''])[1].replace(/\+/g, '%20')
					) || false
				)
			},
			// 获取token
			getToken() {
				if (this.$CONFIG.isVerify && this.isIOS) {
					this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
				} else {
					this.token = this.getcommit('token') || ''
				}
				this.vipId = this.getcommit('vipId') || ''
				console.log(this.token)
			}
		}
	}
</script>

<style lang="less" scoped>
	.applyRefund {
		height: 100%;
		padding-bottom: 1rem;
	}

	.refundInfo {
		padding: .2rem .2rem;

		.refundInfo_1 {
			background: #F9FAFC;
			border-radius: .1rem;
			padding: .3rem 0;

			.refundInfoItem {
				height: .78rem;
				font-size: .28rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				padding: 0 .4rem;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.typeItem {
					color: #999999;
					white-space: nowrap;
				}

				.annotation {
					font-size: .22rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
					line-height: .3rem;
				}

				.valItem {
					color: #222222;
					white-space: nowrap;
				}
			}

			.refundEstimatedAmount {
				height: 1.2rem;

				font-size: .28rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				padding: 0 .4rem;
				display: flex;
				align-items: center;

				.refundEstimatedAmount_1 {
					width: 100%;

					.typeItem {
						color: #999999;
						white-space: nowrap;
						display: flex;
						align-items: center;
						justify-content: space-between;

						.estimatedAmount {
							font-size: .28rem;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #999999;
							line-height: .4rem;
							margin-bottom: .1rem;
							white-space: nowrap;
						}

						.estimatedAmountVal {
							font-size: .4rem;
							font-family: BebasNeue;
							color: #222222;
							line-height: .4rem;
							white-space: nowrap;

							.icon_price {
								font-size: .3rem;
								margin-right: .04rem;
							}
						}
					}

				}
			}

		}
	}

	.collectionBody {
		// margin-top: .51rem;
		padding: 0.3rem 0.4rem;

		.collectionAccount {

			.collectionTitle {
				font-size: .32rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #222222;
				line-height: .45rem;
			}

			.collectionPrompt {
				font-size: .24rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
				line-height: .33rem;
				margin-top: .1rem;
			}

		}

		.filedInfo {
			margin-top: .08rem;

			.van-cell {
				height: 1.2rem;
				align-items: center;
				font-size: .28rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;

			}

			.van-cell::before {
				position: absolute;
				left: 0;
				font-size: .3rem;
				content: '*';
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #F92919;
			}
			
			.van-cell:nth-last-of-type(1)::after{
				display: block;
			}
		}
		
		.filedInfo::after{
			display: none;
		}
	}

	.submit {
		width: 100%;
		background: #ffffff;
		position: fixed;
		bottom: 0;
		padding: 0 .4rem;
		box-sizing: border-box;
		// padding-bottom: constant(safe-area-inset-bottom);
		// padding-bottom: env(safe-area-inset-bottom);

		div {
			height: .96rem;
			margin: .2rem 0;
			font-size: .32rem;
			color: #613F25;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			background: linear-gradient(145deg, #F5E4D3 0%, #C4A485 100%);
			border-radius: .48rem;
			display: flex;
			align-items: center;
			justify-content: center;

		}
	}

	.disbled {
		width: 100%;
		background: #ffffff;
		position: fixed;
		bottom: 0;
		padding: 0 .4rem;
		box-sizing: border-box;
		// padding-bottom: constant(safe-area-inset-bottom);
		// padding-bottom: env(safe-area-inset-bottom);

		div {
			height: .96rem;
			margin: .2rem 0;
			font-size: .32rem;
			color: #666666;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			// background: linear-gradient(145deg, #F5E4D3 0%, #C4A485 100%);
			background: #F7F8FC;
			border-radius: .48rem;
			display: flex;
			align-items: center;
			justify-content: center;

		}
	}

	.prompt {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 100px;
		left: 0;
		background: rgba(0, 0, 0, 0.6);

		.promptDialog {
			width: 100%;
			// height: 7.6rem;
			position: fixed;
			bottom: 0;
			background: #FFFFFF;
			border-radius: .2rem .2rem 0px 0px;

			.promptTitle {
				padding: .4rem .4rem 0.1rem .4rem;
				font-size: .36rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
				line-height: .5rem;
				text-align: center;
			}

			.notice {
				padding: 0 0.86rem .2rem .86rem;
				font-size: .24rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #FF4A4A;
				line-height: .33rem;
				text-align: center;
			}

			.promptAccount {
				height: 1.2rem;
				padding: 0 .8rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-size: .28rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #999990;
				position: relative;

				.prompt_val {
					font-weight: 500;
					color: #222222;
					font-family: PingFangSC-Medium, PingFang SC;
				}
			}

			.promptAccount::after {
				height: 0;
				position: absolute;
				content: ' ';
				left: .8rem;
				right: .8rem;
				bottom: 0;
				opacity: 0.2;
				border: 0.01rem solid #999999;
				-webkit-transform: scaleY(.5);
				transform: scaleY(.5);
			}

			.promptBtn {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: .4rem .4rem 0.2rem;
				font-size: .28rem;
				line-height: .9rem;

				.cancelBtn {
					width: 3.25rem;
					height: .9rem;
					background: #F7F8FC;
					border-radius: .45rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #222222;
					text-align: center;
				}

				.confirm {
					width: 3.25rem;
					height: .9rem;
					background: linear-gradient(145deg, #F5E4D3 0%, #C4A485 100%);
					border-radius: .45rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #613F25;
					text-align: center;
				}
			}
		}
	}
	
	/deep/.van-field__control{
		color: #222222;
		font-weight: 500;
	}

	/deep/.van-field__control::placeholder {
		font-size: .28rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999 !important;
	}
</style>
